export enum ShopTypes {
  MONEY = 'MONEY',
  MILES = 'MILES',
  CASH_PLUS_MILES = 'Cash_Plus_Miles'
}

export enum PriceTypes {
  REVENUE = 'Revenue',
  AWARD = 'Award',
  CASH_PLUS_MILES = 'CashPlusMiles'
}
